import { loginRequest, msalInstance } from '@/app/msal';

const getMicrosoftGraphAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: activeAccount,
  });

  return response.accessToken;
};

export default getMicrosoftGraphAccessToken;
